import makeService from './api';

export default makeService('media_objects');
